import LrrsModelBase from '../_generated/modelBases/lrrs-model-base';

export default class LrrsModel extends LrrsModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
